"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = exports.Footer = exports.Content = exports.AlertButton = exports.Alert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const button_1 = require("@kawaui/button");
const modal_1 = require("@kawaui/modal");
const styled_1 = require("./styled");
Object.defineProperty(exports, "Content", { enumerable: true, get: function () { return styled_1.Content; } });
Object.defineProperty(exports, "Footer", { enumerable: true, get: function () { return styled_1.Footer; } });
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return styled_1.Header; } });
const AlertButton = (props) => ((0, jsx_runtime_1.jsxs)(styled_1.ButtonContainer, { children: [(0, jsx_runtime_1.jsx)(styled_1.ButtonSpace, {}), (0, jsx_runtime_1.jsx)(button_1.Button, Object.assign({}, props))] }));
exports.AlertButton = AlertButton;
const Alert = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return ((0, jsx_runtime_1.jsx)(modal_1.Modal, Object.assign({ disableBackdropEvents: true }, props, { children: (0, jsx_runtime_1.jsx)(styled_1.Container, { children: children }) })));
};
exports.Alert = Alert;
exports.default = Alert;
